module.exports = __webpack_public_path__ + "static/media/ballMachine.4ed68bfc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/ballMachine.gif
// module id = 874
// module chunks = 0